import React, {useEffect, useState} from "react";
import ProviderCard from './ProviderCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProviderSlider.css";

const ProviderList = () => {
    const [physiciansData,setPhysiciansData] = useState([])
    useEffect(()=>{
        window.addEventListener("message", (e) => {
            setPhysiciansData(e.data.value)
        });
    })
    return <>
        <div className="provider-list">

            {
                physiciansData !== undefined && physiciansData.length > 0 ?
                    physiciansData.map((item) => {
                        return <ProviderCard data={item} key={item.id}/>;
                    }) : ''
            }
        </div>
    </>;
};

export default ProviderList;